import { Navigate, Outlet } from "react-router-dom";
import { Show, SignOutButton } from "@clerk/react";
import { Clock } from "lucide-react";
import { AuthBridge, useMe } from "../../lib/api";

const Waiting = ({ email }) => (
  <div data-testid="awaiting-approval" className="flex min-h-screen items-center justify-center px-4">
    <div className="rise max-w-md rounded-lg border border-slate-800 bg-[#131b29]/80 p-8 text-center">
      <Clock className="mx-auto h-10 w-10 text-amber-400" />
      <h1 className="font-display mt-4 text-3xl font-bold uppercase">Waiting for access</h1>
      <p className="mt-3 text-sm text-slate-400">
        You're signed in as <span className="text-slate-200">{email}</span>. An admin needs to give you access before you can use the app.
      </p>
      <SignOutButton>
        <button data-testid="waiting-sign-out-btn" className="mt-6 rounded-md border border-slate-700 px-4 py-2 text-sm text-slate-200 transition-colors hover:bg-slate-800">Sign out</button>
      </SignOutButton>
    </div>
  </div>
);

const MemberGate = () => {
  const { data: me, isLoading, error } = useMe();
  if (isLoading) return <div data-testid="loading-me" className="p-10 font-mono text-sm text-slate-500">Signing in…</div>;
  if (error) return <div data-testid="me-error" className="p-10 text-sm text-red-400">Could not load your account. Refresh to try again.</div>;
  if (me.role === "no_access") return <Waiting email={me.email} />;
  return <Outlet context={{ me }} />;
};

export const Protected = () => (
  <>
    <Show when="signed-in">
      <AuthBridge>
        <MemberGate />
      </AuthBridge>
    </Show>
    <Show when="signed-out">
      <Navigate to="/sign-in" replace />
    </Show>
  </>
);

export const AdminOnly = ({ me, children }) => (me?.role === "admin" ? children : <Navigate to="/" replace />);
